import { AnimatePresence, motion } from 'framer-motion'
import { surfaceVariants } from '@workflow/ui'
import { PageFrame } from '@/shell/PageFrame'
import { AccountPane } from './panes/AccountPane'
import { ApiPane } from './panes/ApiPane'
import { AppearancePane } from './panes/AppearancePane'
import { RuntimesPane } from './panes/RuntimesPane'
import { WorkTypesPane } from './panes/WorkTypesPane'
import { useSession } from '@/lib/api/hooks'
import { settingsGroupsFor } from './sections'

export function SettingsPage({ section }: { section: string }) {
  const role = useSession().data?.account?.role
  const allowed = settingsGroupsFor(role).flatMap((group) => group.sections)
  const current = allowed.some((entry) => entry.id === section) ? section : 'account'
  return (
    <PageFrame title="Settings" description="Manage your account and preferences.">
      {/* The settings tree is one surface, so a section change is a handover
          inside it: both panes share one grid cell for the length of the
          move, the leaving one dissolving as the arriving one settles. */}
      <div className="grid">
        <AnimatePresence initial={false}>
          <motion.div
            key={current}
            style={{ gridArea: '1 / 1' }}
            variants={surfaceVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            {current === 'account' ? (
              <AccountPane />
            ) : current === 'appearance' ? (
              <AppearancePane />
            ) : current === 'work-types' ? (
              <WorkTypesPane />
            ) : current === 'runtimes' ? (
              <RuntimesPane />
            ) : (
              <ApiPane />
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </PageFrame>
  )
}
